import React, { useState } from "react";
import { ClickAwayListener, Typography } from "@material-ui/core";
import { useTheme} from "@material-ui/styles";
import { connect } from "react-redux";

import * as AuthService from "../../../services/auth.service";
import { Avatar, MenuItem, MenuList, Profile, ProfileButton, Divider, LogOutButton } from "./styles";

const UserMenu = ({ history, user }) => {
  const theme = useTheme();

  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(prev => !prev);
  };

  const handleClickAway = () => {
    setOpen(false);
  };

  const logout = () => {
    AuthService.logout().then(res => {
      if (res.data.url) {
        window.location.href = res.data.url;
      }
      localStorage.removeItem('user_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('access_token');
      history.push('/auth/login');
    }).catch(e => console.log(e));
  };

  return (
    <>
      <ClickAwayListener onClickAway={handleClickAway}>
        <div>
          <ProfileButton
            aria-owns={open ? "menu-appbar" : undefined}
            aria-haspopup="true"
            onClick={handleClick}
            color="inherit"
          >
            <Profile>
              <Typography component="h5" align="right">
                { user.name }
              </Typography>
              <Typography component="p" align="right">
                { user.role }
              </Typography>
            </Profile>
            <Avatar src={`/static/img/icons/profile_user--${theme.name}.svg`} />
            <img
              src={`/static/img/icons/arrow-down--${theme.name}.svg`}
              className="arrow-down"
              alt="arrow-down"
            />
          </ProfileButton>
          {open ? (
            <MenuList role="menu">
              <MenuItem>
                <div className="name">
                  <p>{ user.name }</p>
                  <span>{ user.email }</span>
                </div>
              </MenuItem>
              <Divider/>
              <MenuItem>
                <div className="name">
                  <p>Device Phone Number</p>
                  <span>{user.phone}</span>
                </div>
              </MenuItem>
              <Divider/>
              <MenuItem>
                <div className="name">
                  <p>Alchemy Number</p>
                  <span>{user.alchemy_phone_number}</span>
                </div>
              </MenuItem>
              <Divider/>
              <div className="footer">
                <LogOutButton
                  onClick={logout}
                >
                  <img src={`/static/img/icons/logout--${theme.name}.svg`} alt="logout"/>
                  Logout
                </LogOutButton>
              </div>
            </MenuList>
          ) : null}
        </div>
      </ClickAwayListener>
    </>
  );
};

const mapStateToProps = (state) => ({
  user: state.authReducer.user
});

export default connect(mapStateToProps)(UserMenu);
